import type { FilterDefinition } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

export const reimbursableFilter = (): FilterDefinition => ({
  label: i18n.t('expenses_v2.list.filters.payment'),
  type: 'in',
  options: {
    options: [
      { label: i18n.t('expenses_v2.list.filters.reimbursable'), value: 'true' },
      { label: i18n.t('expenses_v2.list.filters.not_reimbursable'), value: 'false' },
    ],
  },
})
